// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "demo" : chunkId) + "." + {"573":"a3342c78","594":"a5702aed","599":"f212b139","604":"218b174a"}[chunkId] + ".js";
};